var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c(
        "div",
        [
          _c("attachment-row", {
            attrs: {
              title:
                "BudgetaryEstimate.Investment.SupportApartments.AttachmentTitle",
              attachment: _vm.model.attachment,
              index: 1
            },
            model: {
              value: _vm.model.attachment,
              callback: function($$v) {
                _vm.$set(_vm.model, "attachment", $$v)
              },
              expression: "model.attachment"
            }
          }),
          _vm._v(" "),
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Investment.Funding.Title")))
          ]),
          _vm._v(" "),
          _c("estimates-and-details-control", {
            attrs: {
              id: "funding-breakdown",
              titleKey:
                "BudgetaryEstimate.Investment.Funding.FundingSupportApartments",
              tableKey: "BudgetaryEstimate.Investment.Funding.Entry",
              showColumnTotals: true,
              showRowTotals: true,
              required: true,
              numericInputRules: _vm.profitsNumericInputRules
            },
            model: {
              value: _vm.fundingWrappers,
              callback: function($$v) {
                _vm.fundingWrappers = $$v
              },
              expression: "fundingWrappers"
            }
          }),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Expenses")))]),
          _vm._v(" "),
          _c("apartment-procurement-control", {
            attrs: { items: _vm.model.apartments }
          }),
          _vm._v(" "),
          _vm.showDescription
            ? _c("text-area-row", {
                attrs: {
                  id: "apartmentdescription",
                  rows: 5,
                  maxLength: 500,
                  required: true,
                  title:
                    "BudgetaryEstimate.Investment.SupportApartments.Apartment.Description",
                  placeholder: "Placeholder.TextArea"
                },
                model: {
                  value: _vm.model.apartmentDescription,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "apartmentDescription", $$v)
                  },
                  expression: "model.apartmentDescription"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("apartment-summary-control", {
            attrs: { items: _vm.model.apartmentSummary }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }